import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {ApplicationDTO} from '../../../../../models/application/ApplicationDTO';
import {ApplicationPersonDTO} from '../../../../../models/application/ApplicationPersonDTO';

enum TableColumns {
  Order = 'order',
  ProviderCode = 'providerCode',
  ProviderName = 'providerName',
}


@Component({
  selector: 'greydom-application-family-providers',
  templateUrl: './application-family-providers.component.html',
  styleUrls: []
})
export class ApplicationFamilyProvidersComponent implements OnChanges {
  readonly tableColumns = TableColumns;

  displayedColumns: string[] = Object.values<string>(TableColumns);
  personList: ApplicationPersonDTO[];

  @Input() application: ApplicationDTO;


  get isDataExist(): boolean {
    if (this.personList) {
      return this.personList?.some(person => person.nominatedFamilyProviders?.length > 0);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.application && changes.application.currentValue) {
      this.personList = this.application?.membership?.persons;
    }
  }
}
